import Sjcl from '@cryptolize/sjcl'

/**
 * Create random string
 *
 * @param {Number} bits number of bits [64, 128, 256]
 * @return {Base64UrlString}
 * @throws {Error} if a generator isn't seeded
 * @public
 */
export function createRandom (bits) {
  return Sjcl.codec.base64url.fromBits(Sjcl.random.randomWords(bits / 32))
}

/**
 * Create encryption key of size 256 bits
 *
 * @return {Base64UrlString}
 * @throws {Error} if a generator isn't seeded
 * @public
 */
export function createKey () {
  return createRandom(256)
}

/**
 * Create initialization vector of size 128 bits
 *
 * @return {Base64UrlString}
 * @throws {Error} if a generator isn't seeded
 * @public
 */
export function createIV () {
  return createRandom(128)
}

/**
 * Create salt of size 64 bits
 *
 * @return {Base64UrlString}
 * @throws {Error} if a generator isn't seeded
 * @private
 */
export function createSalt () {
  return createRandom(64)
}
